export default __webpack_public_path__ + "902e6225075f4dc2f9fe944f578a4ad2.png";